<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import { fetchDataApps } from '../../api.js';
    import UserStore from '../../stores/user.js';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import Header from '../../components/Header.svelte';
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 


    export let params;

    let category_id = params.category_id

    let isLoading = false; 
    
    let views = [];
    
    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
        
        isLoading = true;

        let postData = {
            action : 'get_views',
            token : $UserStore.data,
            category_id
        };
        let data = await fetchDataApps(postData);
        views = data.views;

        isLoading = false;        

 
      
    })    


    async function createNewView() {
        isLoading = true;

        let postData = {
            action : 'create_view',
            token : $UserStore.data,
            category_id
        };
        let data = await fetchDataApps(postData);
        
        views = data.views;
        isLoading = false; 
    }

    


</script>


<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">
        <TopInfo />
        <div class="dash-list">
            <div class="w-full items-end justify-between mb-[30px]">
                <div class="flex justify-between">
                    <h1>{$_('merchandiser.views')}</h1>                
                    <div>
                        <span on:click={()=> createNewView()} class="create_button"><span>{$_('merchandiser.create_view')}</span></span>
                    </div>
                </div>
                <div class="flex">
                    

                    <div class="table table-shipments orders">
                        <div class="head">
                            <div>{$_('merchandiser.name')}</div>
                            <div>{$_('merchandiser.startDate')}</div>
                            <div>{$_('merchandiser.endDate')}</div>
                            <div>{$_('merchandiser.active')}</div>
                            <div></div>
                        </div>
                        {#each views as item,index}
                        <div class="content">                            
                            <div>
                                <div class="mobile">{$_('merchandiser.name')}</div>
                                <div> 
                                    <div>{item.view_name}</div>                          
                                </div>
                            </div> 
                            <div>
                                <div class="mobile">{$_('merchandiser.start')}</div>
                                <div> 
                                    <div>{item.start_datetime}</div>                          
                                </div>
                            </div>
                            <div>
                                <div class="mobile">{$_('merchandiser.end')}</div>
                                <div> 
                                    <div>{item.end_datetime}</div>                          
                                </div>
                            </div>
                            <div>
                                <div class="mobile">{$_('merchandiser.active')}</div>
                                <div> 
                                    <div>{item.active}</div>                          
                                </div>
                            </div>     
  
                            <div>
                                <div class="small_button" on:click={()=> push('/merchandiser/view/' + item.id)}>
                                    <span>{$_('merchandiser.open')}</span>
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </div>
                                
                            </div>
                        </div>
                        {/each}
                    </div>


                </div>                
            </div>            
        </div>
    </div>
</div>